import { IFileType, IFileTypeRequest } from "@/store/types/document-type";
import { EXCLUDE_IN_PROCESS_DOCUMENTS } from "./enumerate";

export const docTypeFilter = (list: IFileType[], filters: IFileTypeRequest) => {
  let document_type: IFileType[] = list;
  if (filters.state)
    document_type = document_type.filter(
      ({ status }: IFileType) => status === filters.state
    );
  if (filters.to_publish)
    document_type = document_type.filter(
      ({ to_publish }: IFileType) => to_publish === filters.to_publish
    );
  if (filters.excludeRequestTypes)
    document_type = document_type.filter(
      ({ id }: IFileType) =>
        !Object.values(EXCLUDE_IN_PROCESS_DOCUMENTS).includes(id as any)
    );

  return document_type;
};
